import { render } from "./TheHeadre.vue?vue&type=template&id=5db36dfa&scoped=true"
const script = {}

import "./TheHeadre.vue?vue&type=style&index=0&id=5db36dfa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db36dfa"]])

export default __exports__